import { PRIVATE_MODULES_PATH } from "./root.path";

const BASE = PRIVATE_MODULES_PATH.PROPERTY;

const ROUTER = {
  ROOT: "",
  DETAIL: "",
  LIST: ""
};

const PATH = {
  ROOT: `/${BASE}`,
  DETAIL: (ID: number) => `/${BASE}/${ID}`,
  LIST: `/${BASE}/${ROUTER.LIST}`
};

const PROPERTY_PATH = {
  ROUTES: PATH,
  ROUTER
};

export default PROPERTY_PATH;
